import { FaCircleCheck } from "react-icons/fa6";
import { aboutHighlights } from "../../data/content";
import useReveal from "../../hooks/useReveal";
import SectionTitle from "../ui/SectionTitle";

export default function About() {
  const imageRef = useReveal();

  return (
    <section className="bg-surface py-20 sm:py-28">
      <div className="container grid items-center gap-14 lg:grid-cols-2">
        <div>
          <SectionTitle eyebrow="Qui sommes-nous ?" title="Sham Dabke, entre tradition et énergie" />

          <p className="mb-5 text-stone-200">
            Sham Dabke est une troupe professionnelle de danse et de percussion originaire de Syrie,
            spécialisée dans l’art traditionnel de la dabké. Notre groupe mixte rassemble des
            danseuses et danseurs expérimentés, engagés dans la préservation et la valorisation du
            patrimoine culturel levantin.
          </p>
          <p className="mb-6 text-stone-200">
            Notre particularité réside dans la polyvalence de nos artistes&nbsp;: chaque membre est à
            la fois danseur(se) et percussionniste, maîtrisant le tambour tout en exécutant les
            chorégraphies. Cette double compétence garantit des prestations dynamiques, cohérentes et
            d’une grande précision artistique.
          </p>

          <ul className="mb-8 space-y-3">
            {aboutHighlights.map((item) => (
              <li key={item} className="flex items-start gap-3 border-b border-white/10 pb-3 text-stone-100">
                <FaCircleCheck className="mt-1 shrink-0 text-gold-500" aria-hidden="true" />
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <div className="flex flex-wrap gap-4">
            <a href="#reservation" className="btn-primary">
              Réserver une prestation
            </a>
            <a href="#rejoignez-nous" className="btn-outline">
              Rejoindre la troupe
            </a>
          </div>
        </div>

        <div ref={imageRef} className="reveal">
          <img
            src="/img/about.png"
            alt="Troupe de dabké Sham Dabke en représentation"
            className="w-full rounded-2xl object-cover shadow-2xl shadow-black/50"
            loading="lazy"
            width={1200}
            height={1400}
          />
        </div>
      </div>
    </section>
  );
}
